/* src/app/components/billing/batches/view-batches/view-batches.component.css */
/*# sourceMappingURL=view-batches.component-LZXKGZZE.css.map */
